import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, 
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem,somethingChanged,heyPricechanged}) => { 
    
    const dispatch = useDispatch()    
    const { user } = useSelector(state => ({
      user: state.auth.user,
    }), shallowEqual)

    const [loading, setLoading] = useState(false)
    const [formSubmitClick, setFormSubmitClick] = useState(false)
    const [costPeso, setCostPeso] = useState(0)
    const [costRMB, setCostRMB] = useState(0)
    const [disableSave, setDisableSave] = useState(true)

    const [useThisItem, setUseThisItem] = useState(null)
    

    const PriceBlueprintLocal =[
      {
        title: 'Peso',
        key: 'cost_peso',
        type: 'number',    
      }, 
    ]

    const PriceBlueprintInt =[
      {
        title: 'RMB',
        key: 'cost_rmb',
        type: 'number',    
      },
    ]

    const PriceBlueprint =[
      {
        title: 'Peso',
        key: 'cost_peso',
        type: 'number',    
      }, 
      {
        title: 'RMB',
        key: 'cost_rmb',
        type: 'number',    
      },
    ]

    useEffect(() => {
  
   
          
      var newthing = {
        ...currentItem,     
      }
      if(costPeso){
        newthing['cost_peso'] = parseFloat(costPeso)
      }
      if(costRMB){
        newthing['cost_rmb'] = parseFloat(costRMB)
      }
  
      setUseThisItem(newthing)
  
    },[costPeso,costRMB]);
    
  

    useEffect(() => {

    
      if(currentItem.cost_peso){
        setCostPeso(currentItem.cost_peso)
      }
      if(currentItem.cost_rmb){
        setCostRMB(currentItem.cost_rmb)
      }
    },[currentItem]);
    useEffect(() => {
      if(heyPricechanged){
        if(heyPricechanged.cost_peso){
          setCostPeso(heyPricechanged.cost_peso)

        }
        if(heyPricechanged.cost_rmb){
          setCostRMB(heyPricechanged.cost_rmb)
        } 
      }
    
    },[heyPricechanged]);


    

    const disableChecker =(e) =>{
      if(e.cost_peso !== costPeso || e.cost_rmb !== costRMB ){
        setDisableSave(false)
      }else{
        setDisableSave(true)
      }

    }

    
    const saveChanges = (form) =>{
 
      console.log('form data',form)
    
      setLoading(true)
      if(form.errorFields){
        form.errorFields.map(er=>{
          er.errors.map(err=>{
            message.error(err)
          })
        })
        setLoading(false)        
      }else if(!currentItem.id ){
        message.error("can't find identifier")
        setLoading(false)
      }else{

          // var formbase ={
          //   cost_peso: null,
          //   cost_rmb:null
          // }
          // if(currentItem.regionalization == 'local'){
          //   formbase['cost_peso'] = form.cost_peso
          // }else{
          //   formbase['cost_rmb'] = form.cost_rmb
          // }

          var newform ={
            ...currentItem,
            ...form,
            updated_at:moment().format('YYYY-MM-DD HH:mm:ss')
          }

          var newPrice ={
            ...form,
            created_by:user.id,
            created_name:user.name,
            created_at:moment().format('YYYY-MM-DD HH:mm:ss')
          }
          dispatch(updateItem(newform,'products',currentItem.id))
          .then(res=>{          
            somethingChanged(true)
            dispatch(setPrice(newPrice,currentItem.id))
            .then(res2=>{          
              somethingChanged(true)
              message.success('changes saved!')
   
              setLoading(false)
            })
            .catch((err2)=>{  
              console.log('err2',err2)
              var formattedErr = errorParser(err2.response)       
              if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
                formattedErr.map(er=>{message.error(er)})
              }else{
                message.error(formattedErr)              
              }
              setLoading(false)
            })
 
          })
          .catch((err)=>{    
            var formattedErr = errorParser(err.response)       
            if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
              formattedErr.map(er=>{message.error(er)})
            }else{
              message.error(formattedErr)              
            }
            setLoading(false)
          })
        
      }  
    }
  






    return(       
      <div className={'productprice'}>
          {useThisItem ? 
          <CreateForm  currentItem={useThisItem}  blueprint={currentItem.regionalization == 'international' ?  PriceBlueprintInt :PriceBlueprintLocal} saveForm={(e)=>{saveChanges(e); setFormSubmitClick(false)}} FormSubmitClick={formSubmitClick} FormOnChange={e=>{disableChecker(e)}}/> 
          :null}
          <Button onClick={()=>{setFormSubmitClick(true)}} loading={loading} disabled={disableSave} type="primary"><SaveOutlined /></Button>
      </div>
    )
}
  
export default Index
  